import React, { useState, useEffect, useContext } from "react";
import peij from "../../../services/peij";
import AppContext from "../../../container/context";
import { AppBar, CircularProgress, Tab, Tabs } from "@mui/material";
import Geral from "./Geral";
import Aulas from "./Aulas";
import Conteudo from "./Conteudo";
import ijws from "../../../services/ijws";

const Unidade = ({ match, history }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [unidadeId] = useState(Number(match.params.id));
  const [unidade, setUnidade] = useState({});
  const [comboNivel, setComboNivel] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    carregarComboNivel();
    carregarUnidade();
  }, []);

  const carregarComboNivel = () => {
    setCarregando(true);
    ijws
      .get("admin/niveis/listar")
      .then((comboNivel) => {
        setComboNivel(comboNivel);
        setCarregando(false);
      })
      .catch((err) => notification("error", "Erro ao listar os níveis"));
  };

  const carregarUnidade = () => {
    if (unidadeId > 0) {
      setCarregando(true);
      ijws
        .get("admin/unidades/carregar", { id: unidadeId })
        .then((unidade) => {
          setUnidade(unidade);
          setCarregando(false);
        })
        .catch((err) => notification("error", "Erro ao carregar a unidade"));
    }
  };

  if (carregando) return <CircularProgress />;

  if (unidadeId === 0)
    return (
      <Geral
        unidadeId={unidadeId}
        unidade={unidade}
        history={history}
        comboNivel={comboNivel}
      />
    );

  const tabs = [
    {
      label: "Geral",
    },
    {
      label: "Conteúdo (visão geral)",
    },
    {
      label: "Aulas",
    },
  ];

  // const handleChangeIndex = (index) => {
  //   setActiveIndex(index);
  // };

  const handleChange = (event, value) => {
    setActiveIndex(value);
  };

  return (
    <div>
      <AppBar position="static" color="default">
        <Tabs
          value={activeIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollable
          scrollButtons="auto"
        >
          {tabs && tabs.map((tab, key) => <Tab key={key} label={tab.label} />)}
        </Tabs>
      </AppBar>

      {activeIndex === 0 && (
        <Geral
          unidadeId={unidadeId}
          unidade={unidade}
          comboNivel={comboNivel}
          history={history}
        />
      )}
      {activeIndex === 1 && (
        <Conteudo unidadeId={unidadeId} history={history} />
      )}
      {activeIndex === 2 && <Aulas unidadeId={unidadeId} history={history} />}
    </div>
  );
};

export default Unidade;
